<template>
  <div class="userinfo-form">
    <!-- 会員情報変更の場合のみ表示 -->
    <div v-if="mode === DisplayModeCode.CHANGE" class="row q-gutter-sm q-mb-md">
      <div class="col">
        <label>会員ID（メールアドレス）</label>
        <p class="q-mb-none q-ml-sm q-mt-sm">
          {{ inputData.mail_address }}
        </p>
      </div>
    </div>
    <div class="row q-gutter-sm">
      <div class="col">
        <label for="name" class="requier">お名前（姓）</label>
        <q-input
          ref="nameSeiElem"
          v-model="inputData.user_name_sei"
          outlined
          maxlength="100"
          dense
          :rules="[
            (val) => isEmpty(val) || $t('validation.required'),
            (val) => !isHalfKana(val) || $t('validation.half_kana'),
          ]"
          lazy-rules
          autofocus
          class="input-area"
          hint="例）山田"
          @keydown.enter.prevent
        />
      </div>
      <div class="col">
        <label class="requier">お名前（名）</label>
        <q-input
          v-model="inputData.user_name_mei"
          outlined
          dense
          maxlength="100"
          :rules="[
            (val) => isEmpty(val) || $t('validation.required'),
            (val) => !isHalfKana(val) || $t('validation.half_kana'),
          ]"
          lazy-rules
          class="input-area"
          hint="例）太郎"
          @keydown.enter.prevent
        />
      </div>
    </div>
    <!-- 新規会員登録の場合のみ表示 -->
    <div v-if="mode === DisplayModeCode.REGISTER" class="row q-gutter-sm">
      <div class="col">
        <label class="requier">会員ID（メールアドレス）</label>
        <q-input
          ref="mailaddressElem"
          v-model="inputData.mail_address"
          outlined
          type="email"
          dense
          maxlength="254"
          :rules="[
            (val) => isEmpty(val) || $t('validation.required'),
            (val) => isValidateEmail(val) || $t('validation.email'),
          ]"
          lazy-rules
          class="input-area left-input"
          hint="例）example@xxx.com"
          :error="props.isMailAddressErr"
          @update:model-value="emit('isMailAddressErr', false)"
          @keydown.enter.prevent
        />
      </div>
    </div>
    <!-- 新規会員登録の場合のみ表示 -->
    <div v-if="mode === DisplayModeCode.REGISTER" class="row q-gutter-sm">
      <div class="col">
        <label class="requier">会員ID（メールアドレス）確認</label>
        <q-input
          v-model="inputData.mail_address_conf"
          outlined
          dense
          type="email"
          maxlength="254"
          :rules="[
            (val) => isEmpty(val) || $t('validation.required'),
            (val) => isValidateEmail(val) || $t('validation.email'),
            (val) => val === inputData.mail_address || $t('validation.same_email'),
          ]"
          reactive-rules
          class="input-area left-input"
          @keydown.enter.prevent
        />
      </div>
    </div>
    <div class="row q-gutter-sm">
      <div class="col">
        <label class="requier">ご担当</label>
        <UserAttributeRadio
          :value="inputData.user_attribute"
          @select-value="inputData.user_attribute = $event"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import UserAttributeRadio from '../../radio/UserAttributeRadio.vue';
import DisplayModeCode from '../../../common/code/DisplayModeCode';
import { isEmpty, isHalfKana, isValidateEmail } from '../../../common/utils/validateUtils';

interface Props {
  // ユーザー情報
  memberInfo: {
    user_name_sei: string;
    user_name_mei: string;
    mail_address: string;
    mail_address_conf: string;
    user_attribute: string;
  };
  // メールアドレスエラーフラグ
  isMailAddressErr?: boolean;
  // 表示モード
  mode: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:inputData', 'isMailAddressErr']);

// 入力値
const inputData = computed({
  get: () => props.memberInfo,
  set: (value) => {
    emit('update:inputData', value);
  },
});
</script>

<style scoped>
.userinfo-form {
  width: 600px;
  margin: 0 auto;
}
.userinfo-form .row.q-gutter-sm {
  margin-top: 5px;
}
.userinfo-form .row.q-gutter-sm:first-child {
  margin-top: 0;
}
</style>
